module.exports = __webpack_public_path__ + "img/invite-friend.1ebea9c9.png";